// Date 2023-06-26 13:00:19

import agreementContent from "@/views/sithMes/agreement/AgreementContent";
import agreementList from "@/views/sithMes/agreement/AgreementList";

const metaObject = {requiresAuth: true, roles: ['mmf']};

export default [
    {
        path: "/sithMes/agreement/agreementContent",
        name: "agreementContent",
        component: agreementContent,
    },
    {
        path: "/sithMes/agreement/agreementList",
        name: "agreementList",
        component: agreementList,
        meta: metaObject
    }
]
